import { HttpEvent } from '@angular/common/http';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { FileUploadErrorEvent } from 'primeng/fileupload';
import { Observable, Subject, takeUntil } from 'rxjs';
import { AuthRoles } from 'src/app/auth/auth.types';
import { AdminService } from 'src/app/services/admin.service';
import { AttachmentService } from 'src/app/services/attachment.service';
import { AppUtils } from 'src/app/shared/app.utils';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'ness-manage-attachments',
  templateUrl: './manage-attachments.component.html'
})
export class ManageAttachmentsComponent implements OnInit, OnDestroy {
  attachmentTypes$: Observable<ServerModels.ENESS_REF_AttachmentTypes[]> = this.attachmentsService.attachmentTypesSubj.asObservable();
  apiRoot: string = environment.apiEndpoint;
  cols: any[] = [];
  hasNESSAdmin: AuthRoles[] = ['NESS Administrator'];
  attachmentsGrid: any[] = [];
  maxFileSize: number = environment.maxUploadFileSizeInBytes; //5mb
  selectedAttachmentType: string = '';
  uploadPath: string = '/api/Attachments/UploadAttachment';
  uploadUrl: string = null;

  private _unsubscribe$: Subject<void> = new Subject<void>();
  @ViewChild('downloadTemplateLink', { static: false }) private downloadTemplateLink: ElementRef;

  constructor(private adminService: AdminService,
    private attachmentsService: AttachmentService,
    private messageService: MessageService) { }

  ngOnInit() {
    this.cols = [
      { field: 'AttachmentTypes', header: 'Template Type' },
      { field: 'FileName', header: 'Filename' },
      { field: 'CreatedOn', header: 'Last Updated' }
    ];
    this.attachmentsService.getAllAttachmentTypes();
    this.getAttachmentsGrid();
  }

  ngOnDestroy() {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  private getAttachmentsGrid() {
    this.adminService.getAttachmentsGrid().pipe(takeUntil(this._unsubscribe$)).subscribe({
      next: (data: ServerModels.ENESS_ApplicationAttachment[]) => {
        if (data.length > 0) {
          this.attachmentsGrid = data;
        }
      }
    });
  }

  public onClickDownload(importTemplate: ServerModels.ENESS_ApplicationAttachment) {
    if (!AppUtils.objectIsEmpty(importTemplate)) {
      const blob = AppUtils.base64toBlob(importTemplate.Attachment, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
      const link = this.downloadTemplateLink.nativeElement;
      const url = window.URL.createObjectURL(blob);
      link.href = url;
      link.download = importTemplate.FileName;
      link.click();
      window.URL.revokeObjectURL(url);
    }
  }

  public onUploadHandler(event: { originalEvent: HttpEvent<any>, files: File[] }) {
    this.messageService.add({ key: 'tempUploadMsgs', severity: 'success', summary: 'Success', detail: 'File upload successful.' });
    this.getAttachmentsGrid();
    this.selectedAttachmentType = '';
  }

  public onUploadError(evt: FileUploadErrorEvent): void {
    let filesNotUploaded: string = '';
    for (let i = 0; i < evt.files.length; i++) {
      filesNotUploaded += evt.files[i].name;
      if (i < evt.files.length - 1) {
        filesNotUploaded += ',';
      }
    }

    this.messageService.add({ key: 'tempUploadMsgs', severity: 'error', summary: 'Error', detail: 'An error occurred. The following files were not uploaded ' + filesNotUploaded });
  }

  public buildUploadURL() {
    this.uploadUrl = this.apiRoot + this.uploadPath + "?" + this._getAttachmentTypeParam();
  }

  private _getAttachmentTypeParam(): string {
    return "attachmentType=" + this.selectedAttachmentType;
  }
}
